module.exports = "/_next/static/images/ChatbotsBarCharts@2x-aebd0d20671706e3488445d9f86db2cd.webp";